import React from 'react';

const SuccessIcon = ({ height = '98', width = '98' }) => {
  return(
    <svg width={width} height={height} viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M49 6.125C25.323 6.125 6.125 25.323 6.125 49C6.125 72.677 25.323 91.875 49 91.875C72.677 91.875 
          91.875 72.677 91.875 49C91.875 25.323 72.677 6.125 49 6.125ZM67.5186 34.9986L47.3635 62.9439C47.0818 
          63.3371 46.7104 63.6575 46.2802 63.8785C45.8499 64.0995 45.3732 64.2148 44.8895 64.2148C44.4059 
          64.2148 43.9292 64.0995 43.4989 63.8785C43.0687 63.6575 42.6973 63.3371 42.4156 62.9439L30.4814 
          46.4064C30.1178 45.8992 30.4814 45.191 31.1035 45.191H35.592C36.5682 45.191 37.4965 45.66 38.0707 
          46.4639L44.8848 55.9193L59.9293 35.0561C60.5035 34.2617 61.4223 33.7832 62.408 33.7832H66.8965C67.5186 
          33.7832 67.8822 34.4914 67.5186 34.9986Z" 
        fill="#19CFA9"/>
    </svg>
  );
};

export default SuccessIcon;